<generic-modal #tabList>
	<ng-template #modalHeading>
		<div class="header-container">
			<div class="name-container">
				<span class="site-name">{{ binderDetails?.accountSiteName }}</span>
				<span class="resource-name">{{ binderDetails?.accountSiteResourceName }}</span>
			</div>
			<button mat-button (click)="close()">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</ng-template>
	<ng-template #modalBody let-data="years">
		<div class="main-container">
			<div class="labels">
				<span>Send documentation:</span>
				<span>To: <span class="email">{{targetEmail}}</span></span>
			</div>
			<form class="main-form disable-form" [formGroup]="selectedBinderTabsForm" id="sendDocumentationForm" (ngSubmit)="sendDocuments();">
				<div class="year-selection">
					<span>Binder Year:</span>
					<mat-form-field class="container">
						<mat-select formControlName="year">
							<mat-option *ngFor="let year of years" [value]="year">
								{{year}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="select-binder"><span>Select Binder Tabs Documents:</span></div>
				<fieldset>
					<app-loader *ngIf="isDataLoading"></app-loader>
					<ng-container *ngIf="!isDataLoading">
						<ng-container *ngIf="isTabListEmpty">
							<div class="empty-list">
								No documents found
							</div>
						</ng-container>
						<ul>
							<li *ngFor="let tabGroup of binderClassificationIds.controls;let index" [formGroup]="tabGroup" >
								<mat-checkbox [disabled]="selectedBinderTabsForm.get('value')?.disabled"
								formControlName="value"
								[class.hidden]="!tabGroup.get('isVisible')?.value">
									<span [class.child-checkbox]="!tabGroup.get('isParent')?.value">{{getTabDetails(tabGroup.get('binderClassificationId')?.value)?.binderName}}</span>
								</mat-checkbox>
							</li>
						</ul>
					</ng-container>

				</fieldset>
			</form>

		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-button type="submit" form="sendDocumentationForm" [disabled]="!selectedBinderTabsForm.valid || isDataLoading">Send Documents</button>
	</ng-template>
</generic-modal>
